import React from 'react';
import { buildClassName } from '../../../utils';
import { ChevronIcon } from './ChevronIcon';
import styles from '../DesktopNavigation.module.scss';

/**
 * @internal
 * Dropdown arrow component used by navigation items that have dropdowns.
 * This component is an internal implementation detail of the navigation module.
 * Do not import or use this component directly from outside the navigation module.
 */

interface DropdownArrowProps {
  isExpanded?: boolean;
  styleOverrides?: {
    icon?: string;
  };
}

export const DropdownArrow = ({ 
  isExpanded = false, 
  styleOverrides = {},
}: DropdownArrowProps) => {
  return (
    <ChevronIcon 
      isExpanded={isExpanded}
      className={buildClassName(styles.dropdownArrow, isExpanded && styles.dropdownArrowExpanded)}
      width={24}
      height={24}
      styleOverrides={styleOverrides}
    />
  );
}; 